import RouteScrollToTop from './RouteScrollToTop';
export default RouteScrollToTop;
